import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Icon } from '@material-ui/core';

const withSpinner = (Component, duration = 1500) => {
  const Spinner = ({ classes, style = {} }) => (
    <Icon className={classes.spinner} style={style} color={style.color}>
      <Component />
    </Icon>
  );

  return withStyles({
    '@keyframes spinner': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(359deg)' },
    },
    spinner: {
      animation: `spinner ${duration}ms infinite linear`,
    },
  })(Spinner);
};

export default withSpinner;
